module.exports = __webpack_public_path__ + "media/music/piano_chords_3-f37a4fe7.mp3";